"use client";

import { programData, TutorData } from "@/data/mentors";
import Aos from "aos";
import { useEffect, useState } from "react";

interface SearchBarProps {
  onResults: (results: TutorData[]) => void;
}

export default function SearchBar({ onResults }: SearchBarProps) {
  const [query, setQuery] = useState("");
  const [expertise, setExpertise] = useState("");

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);
  useEffect(() => {
    if (query.trim() === "" && expertise === "") {
      onResults(programData);
    }
  }, [query, expertise]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const q = query.trim().toLowerCase();
    const exp = expertise.toLowerCase();

    const results = programData.filter((item) => {
      const matchesQuery =
        !q ||
        item.title.toLowerCase().includes(q) ||
        item.subtitle.toLowerCase().includes(q) ||
        item.desc.toLowerCase().includes(q) ||
        item.tags.some((tag) => tag.toLowerCase().includes(q));

      const matchesExpertise =
        !exp || item.tags.some((tag) => tag.toLowerCase().includes(exp));

      return matchesQuery && matchesExpertise;
    });

    onResults(results);
  };

  return (
    <div
      className="flex flex-col w-full bg-white rounded-2xl shadow-lg p-6 md:p-10 gap-2"
      data-aos="fade-up"
    >
      <h1 className="text-xl md:text-xl font-medium text-gray-900 text-left">
        Search Tutor
      </h1>
      <form
        onSubmit={handleSubmit}
        className="w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4"
      >
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search by name, expertise, or availability"
          className="w-full sm:w-2/3 border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-[#CC0007] focus:border-transparent transition-colors duration-300"
        />
        <select
          value={expertise}
          onChange={(e) => setExpertise(e.target.value)}
          className="w-full sm:w-1/3 border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:ring-2 focus:ring-[#CC0007] focus:border-transparent transition-colors duration-300 cursor-pointer"
        >
          <option value="" disabled>
            Speciality
          </option>
          <option value="business">Business</option>
          <option value="general">General</option>
          <option value="culture">Culture</option>
        </select>
        <button
          type="submit"
          className="bg-[#FF0000] hover:bg-[#D6001C] text-white font-bold py-2 px-6 rounded-lg shadow-md transition-transform duration-300 transform hover:scale-105 w-full sm:w-auto"
        >
          Search
        </button>
      </form>
    </div>
  );
}
